import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/boba/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: false,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  SAFE_UTILS_SUPPORTED: false,
  LOGO_DIMENSIONS: {
    HEADER: {
      H: '45px',
    },
    WELCOME: {
      W: '160px',
      H: '48px',
    },
  },
  IS_LICENSED: false,
} as TemplateConfig
export default TEMPLATE_CONFIG
